import { render } from "./Click15ShortIcon.vue?vue&type=template&id=ddbf28a8"
import script from "./Click15ShortIcon.vue?vue&type=script&lang=js"
export * from "./Click15ShortIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__